import { useEffect, useMemo } from 'react';
import { AdminLayout } from '../../components/AdminLayout';
import { parseChangelog, markChangelogSeen } from '../../utils/changelog';

/**
 * Neuigkeiten: rendert das Änderungsprotokoll (CHANGELOG.md, beim Build
 * eingebettet — keine API nötig). Beim Öffnen wird die neueste Version als
 * "gesehen" gemerkt, damit der Hinweispunkt in der Navigation verschwindet.
 */
export default function ChangelogPage() {
  const entries = useMemo(() => parseChangelog(), []);

  useEffect(() => {
    markChangelogSeen();
  }, []);

  return (
    <AdminLayout>
      <div className="max-w-3xl">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-slate-900">Neuigkeiten</h1>
          <p className="text-sm text-slate-500 mt-1">
            Was sich mit den einzelnen Versionen geändert hat.
          </p>
        </div>

        <div className="space-y-6">
          {entries.map((entry) => (
            <section key={entry.version} className="bg-white rounded-lg border p-6">
              <div className="flex items-baseline justify-between border-b pb-2 mb-4">
                <h2 className="text-lg font-semibold text-slate-900">
                  Version {entry.version}
                </h2>
                {entry.date && <span className="text-sm text-slate-500">{entry.date}</span>}
              </div>
              <div className="space-y-4">
                {entry.groups.map((group, gi) => (
                  <div key={gi}>
                    {group.title && (
                      <h3 className="text-sm font-medium text-slate-700 mb-1">{group.title}</h3>
                    )}
                    <ul className="list-disc pl-5 space-y-1 text-sm text-slate-700">
                      {group.items.map((item, ii) => (
                        <li key={ii}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
}
